// Типы подарков
export enum GiftType {
  CHEST = "chest",
  LETTER = "letter",
  HEART = "heart",
}

// Типы морских предметов
export enum SeaObjectType {
  WATER = "water",
  BOTTLE = "bottle",
  BEAM = "beam",
  BOAT = "boat",
  FUNNEL = "funnel",
  EDGE_ISLAND_0 = "edge-island-0",
  EDGE_ISLAND_45 = "edge-island-45",
  EDGE_ISLAND = "edge-island",
  SAND_ISLAND = "sand-island",
  ISLAND_SAND_CHEST = "island-sand-chest",
  CHEST_SEA = "chest-sea",
  GRASS_EDGE_0 = "grass-edge-0",
  GRASS_EDGE_45 = "grass-edge-45",
  GRASS_EDGE = "grass-edge",
  GRASS = "grass",
  TREE = "tree",
  WOMAN_SAND_LIES = "woman-sand-lies",
  WOMAN_SAND_LIES2 = "woman-sand-lies2",
  WOMAN_SEA_LIES = "woman-sea-lies",
  MAN_SAND_LIES = "man-sand-lies",
  MAN_SEA_LIES = "man-sea-lies",
  MAN_SAND = "man-sand",
  BOTTLE_SAND = "bottle-sand",
  SHIP_LEFT = "ship-left",
  SHIP_RIGHT = "ship-right",
  CLOUD = "cloud",
}

export interface Gift {
  type: GiftType;
  text: string;
}

export interface SeaObject {
  type: SeaObjectType;
  rotation: number; // 0, 90, 180, 270
  text?: string; // Текст послания для интерактивных объектов
  age?: number; // Возраст для мужчин и женщин
}

export interface TileData {
  tileCode: SeaObjectType; // Конкретный код клетки (water, sand-island, edge-island-0 и т.д.)
  gift?: Gift;
  seaObject?: SeaObject;
  hasClouds?: boolean; // Флаг наличия облаков на этой клетке
}

// Типы для кодов активации
export interface ActivationCode {
  id: number;
  code: string;
  isUsed: boolean;
  isDownloaded: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateActivationCodeDto {
  code: string;
}

// Типы для истории активаций
export interface ActivationHistoryEntry {
  id: number;
  code: string;
  activationCodeId: number;
  tileData: {
    x: number;
    y: number;
    type: string;
    giftType?: string;
    seaObjectType?: string;
    text?: string;
  };
  messageTitle: string;
  messageContent: string;
  imageUrl?: string;
  createdAt: string;
}

export interface CreateActivationHistoryDto {
  code: string;
  tileData: {
    x: number;
    y: number;
    type: string;
    giftType?: string;
    seaObjectType?: string;
    text?: string;
  };
  messageTitle: string;
  messageContent: string;
  imageUrl?: string;
}
